const SET_ERROR = 'SET_ERROR'
export type FieldType = {
    name: string
    type : 'text' | 'email' | 'phone' | 'date' | 'checkbox' | 'file' | 'signature' | 'password'
    placeholder: string
}
export type LoginFieldsType = Array<FieldType>
const initialState = {
    login: {
        type: 'login' as string,
        fields: [
            {
                name: 'email' as string,
                placeholder: 'E-mail' as string
            },
            {
                name: 'password' as string,
                placeholder: 'Password' as string
            },


        ] as LoginFieldsType,
        title: 'Acceso',
        instruction: 'Utilice su correo electrónico y contraseña para continuar',
        forgotLink: `¿Has olvidado tu contraseña?`,
        footerInstruction: `¿Aún no tienes una cuenta?`,
        footerLink: `Sign up`
    },
    registration: {
        type: 'registration',
        fields: [
            {
                name: 'name' as string,
                type: 'text',
                placeholder: 'Nombre' as string
            },
            {
                name: 'surname' as string,
                type: 'text',
                placeholder: 'Apellido' as string
            },
            {
                name: 'email' as string,
                type: 'email',
                placeholder: 'E-mail' as string
            },
            {
                name: 'phone' as string,
                type: 'phone',
                placeholder: 'Número de teléfono' as string
            },
            {
                name: 'date' as string,
                type: 'date',
                placeholder: 'Fecha de cumpleaños' as string
            },
            {
                name: 'documentType' as string,
                type: 'options',
                placeholder: 'Tipo de Documento' as string
            },
            {
                name: 'documentNumber' as string,
                type: 'text',
                placeholder: 'Número del Documento' as string
            },
            {
                name: 'documentFirst' as string,
                type: 'file',
                placeholder: 'Tamaño de la foto del documento 1' as string
            },
            {
                name: 'documentSecond' as string,
                type: 'file',
                placeholder: 'Tamaño de la foto del documento 2' as string
            },
            {
                name: 'signature' as string,
                type: 'canvas',
                placeholder: 'Su firma' as string
            },
            {
                name: 'password' as string,
                type: 'password',
                placeholder: 'Contraseña' as string
            },
            {
                name: 'repeatPassword' as string,
                type: 'password',
                placeholder: 'Repita la contraseña' as string
            },


        ]as Array<FieldType>,
        title: 'Únete Ya! ',
        instruction: 'Crea una cuenta para continuar y conectarte con El Gran Kush.',
        privacy: `Al presionar Registrarse, acepta los Términos de servicio y la Política de privacidad.`,
        footerInstruction: `¿Ya tienes una cuenta? `,
        footerLink: `Sign In`
    },
    error: '' as string
}
export type LoginRegistrationType = typeof initialState
// export type LoginFieldsType = typeof initialState.login.fields
// export type RegistrationFieldsType = typeof initialState.registration.fields

export const setError = (error: string):SetErrorType => {

    return {
        type: SET_ERROR,
        error
    }
}
export type SetErrorType = {
    type: typeof SET_ERROR,
    error: string
}
const LoginRegistrationReducer = (state: LoginRegistrationType = initialState, action: any): LoginRegistrationType => {

    switch (action.type) {
        case SET_ERROR:
            let result = { ...state }
            result.error = action.error
            return result

        default:
            return state
    }

}

export default LoginRegistrationReducer